import { render, staticRenderFns } from "./rightAndAnalysis.vue?vue&type=template&id=54c68f98"
import script from "./rightAndAnalysis.vue?vue&type=script&lang=js"
export * from "./rightAndAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports